let view = null;

export default {
	namespace: 'single-project',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: ProjectView } = await import(
			/* webpackChunkName: "project-view" */ '../../templates/ProjectView'
		);
		view = new ProjectView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
